import onDocumentReady from 'shared/onDocumentReady';
import { createApp } from '~/vue/createApp';
import HelpDesk from './HelpDesk';

// the placeholder lives in base.html, so the panel is on every page - it used to
// be a bundle of its own, rendered at the end of the body; now it is one of the
// site wide mounts the main bundle brings, and waits for the document like they do
//
// see site_header/index.js for what the conversion from `new Vue({el, render})` changes.
// The old render read `this.props` off the wrapper root and passed it on as `attrs`, which
// resolved to nothing every time: a root built from an options object has no `props` of its
// own, HelpDesk declares none, and the placeholder carries no dataset to fill them from
function initVue () {
    const el = document.getElementById('vue-help-panel');
    if (!el) {
        return;
    }
    createApp(HelpDesk).mount(el);
}

onDocumentReady(initVue);
